import {GetControlCardInstanceDocument, type GetControlCardInstanceQuery} from "app/gql/graphqlSchema";
import {useQuery} from "app/employee/controlCard/hook/useQuery";

const resultMapper = (data: GetControlCardInstanceQuery) => data.controlCardInstance;

export const useControlCardInstance = () => useQuery(GetControlCardInstanceDocument, resultMapper);
